import { Tag } from 'antd';
const CountryAreaTags = ({ value }) => {

    return (
        <>
            {
                value?.map((area, index) => {
                    return (
                        <Tag color="blue" key={index}>
                            {
                                [area.countryName, area.provinceName, area.cityName, area.districtName]
                                    .filter(name => name)
                                    .join('')
                            }
                        </Tag>
                    )
                })
            }
        </>
    )
}

export default CountryAreaTags;